module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "待发货"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "待收货"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "已完成"
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.goOrderDetail(order.id, order.type, order)
        }
      }
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": "https://static.dierqudao.com/images/dinghuoxitong/icon-date.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(order.predict_time_str) + " 出货")])]), _vm._v(" "), _c('div', {
      staticClass: "title-right"
    }, [_vm._v("\n                                " + _vm._s(order.status_buttons.name) + "\n                            ")])]), _vm._v(" "), _vm._l((order.items), function(goods, index) {
      return (index < 3) ? _c('div', {
        key: index,
        staticClass: "justify-space-flex row-goods"
      }, [_c('div', {
        staticClass: "row-left flex-start"
      }, [_c('img', {
        staticClass: "row-left-img",
        attrs: {
          "src": goods.pic_url,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "goods-detail"
      }, [_c('div', {
        staticClass: "goods-name"
      }, [_vm._v(_vm._s(goods.title))]), _vm._v(" "), _c('div', {
        staticClass: "goods-weight gray-light"
      }, [_vm._v("\n                                        " + _vm._s(goods.sku.sku_formart) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
        staticClass: "row-right"
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.userType == 1),
          expression: "userType==1"
        }],
        staticClass: "goods-price"
      }, [_c('span', [_vm._v("¥")]), _vm._v("{{goods.goods_price_base/100")]), _vm._v(" "), _c('div', {
        staticClass: "goods-num gray-light"
      }, [_vm._v("数量 " + _vm._s(goods.count))])])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "row-btn"
    }, [(order.items.length < 3) ? _c('div', {
      staticClass: "look-order"
    }, [_vm._v("查看订单")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "look-order",
      attrs: {
        "else": ""
      }
    }, [_vm._v("查看更多")]), _vm._v(" "), _vm._l((order.status_buttons.buttons), function(btn, index) {
      return (btn.type == 'pay' || btn.type == 'count_edit') ? _c('div', {
        key: index,
        class: btn.class
      }, [(btn.type == 'pay' || btn.type == 'count_edit') ? _c('span', [_vm._v(" " + _vm._s(btn.name))]) : _vm._e()]) : _vm._e()
    })], 2)], 2)
  }), 0)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46a08832","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/StationList.vue
// module id = 2357
// module chunks = 0